import { getTableSelectionIndices } from 'components/atoms/Table/utils';
import { uniq } from 'lodash';
import difference from 'lodash/difference';

export type HandleSelectOptions = {
  currentSelectIndex: number;
  lastToggledIndex: number | undefined;
  selectedIds: string[];
  rowsIds: string[];
  selectableRowsIds?: string[];
  checked: boolean;
  isPressingShift?: boolean;
};

/*

 exposes a function we can call on row selection,
 handles selecting a row while pressing on shift,
 it should behave similary to gmail's table selection i guess 

*/

const useTableSelection = () => {
  const handleSelectOptions = ({
    currentSelectIndex,
    lastToggledIndex,
    selectedIds,
    rowsIds,
    selectableRowsIds,
    checked,
    isPressingShift,
  }: HandleSelectOptions) => {
    if (isPressingShift && lastToggledIndex != null) {
      const indices = getTableSelectionIndices(
        currentSelectIndex,
        lastToggledIndex,
      );
      const allIds = indices.map((i) => rowsIds[i]);
      const ids = selectableRowsIds
        ? allIds.filter((id) => selectableRowsIds.includes(id))
        : allIds;
      if (checked) {
        return uniq(selectedIds.concat(ids));
      }
      return difference(selectedIds, ids);
    }
    const currentSelectId = rowsIds[currentSelectIndex];
    if (selectableRowsIds && !selectableRowsIds.includes(currentSelectId)) {
      return selectedIds;
    }
    return checked
      ? selectedIds.concat(currentSelectId)
      : selectedIds.filter((id) => id !== currentSelectId);
  };

  return handleSelectOptions;
};

export default useTableSelection;
